import { useWorker } from '@Components/Shared/WebWorker';

const facetedSearchReducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return {
                ...state,
                ...action.payload,
                SearchWorker: getFacetedSearchWorker(state.SearchWorker, action.payload.SearchDispatcher)
            };
        case 'destroy':
            return {
                Options: [],
                ShowLoadingSpinner: true,
                SearchWorker: state.SearchWorker
            };
        default:
            return state;
    }
};

const getFacetedSearchWorker = (worker, dispatcher) => {
    if (worker) {
        return worker;
    } else {
        return useWorker(() => {
            self.addEventListener('message', (e) => {
                if (e.data.nestedTree) {
                    const search = (option, text, parentMatches, selectedFilterOptions, parentIsFilterBySelected, searchResult) => {
                        searchResult.push(option);
                        option.Visible = false;
                        let addParent = false;
                        let isFilterBySelected = false;
                        let filterBySelectionsAreChecked = false;
                        if (selectedFilterOptions && selectedFilterOptions.length > 0) {
                            filterBySelectionsAreChecked = true;
                            isFilterBySelected = selectedFilterOptions.some(item => item.Value == option.Value);
                        }
                        if (((!text || text === '') || anyMatches(option.Name, text)) &&
                            (isFilterBySelected || !filterBySelectionsAreChecked || parentMatches || parentIsFilterBySelected)) {
                            addParent = true;
                            option.Visible = true;
                        }
                        if (option.Children && option.Children.length > 0) {
                            let children = [];
                            let childrenLength = option.Children.length;
                            for (var i = 0; i < childrenLength; i++) {
                                let child = search(option.Children[i], text, (parentMatches || addParent), selectedFilterOptions, (parentIsFilterBySelected || isFilterBySelected), searchResult);
                                children.push(child);
                                if (child.Visible) {
                                    option.Visible = true;
                                }
                            }
                            option.Children = children;
                        }
                        return option;
                    };
                    let selectedFilterOptions = e.data.selectedFilterOptions;
                    if (!selectedFilterOptions) {
                        if (e.data.filterOptions.length > 0) {
                            selectedFilterOptions = e.data.filterOptions.filter(option => option.Checked);
                        }
                    }
                    let nestedTree = [];
                    let searchResult = [];
                    let searchText = e.data.text.toLowerCase();
                    e.data.nestedTree.forEach(option => nestedTree.push(search(option, searchText, false, selectedFilterOptions, false, searchResult)));
                    postMessage({
                        searchResult: searchResult,
                        nestedTreeResult: nestedTree
                    });
                }

                function anyMatches(fullText, typed) {
                    var text = fullText.toLowerCase();
                    var typedText = typed.toLowerCase();
                    var match = text.indexOf(typedText) !== -1;

                    if (!match) {
                        text = replaceSpecialCharacters(text);
                        typedText = replaceSpecialCharacters(typedText);
                        match = text.indexOf(typedText) !== -1
                    }

                    return match;
                };

                //Can't pass function/library into web workers so creating custom method
                function replaceSpecialCharacters(text) {
                    return text
                        .replace(/\u00c0/g, 'a') //À
                        .replace(/\u00e0/g, 'a') //à
                        .replace(/\u00c1/g, 'a') //Á
                        .replace(/\u00e1/g, 'a') //á
                        .replace(/\u00c2/g, 'a') //Â
                        .replace(/\u00e2/g, 'a') //â
                        .replace(/\u00c3/g, 'a') //Ã
                        .replace(/\u00e3/g, 'a') //ã
                        .replace(/\u00c4/g, 'a') //Ä
                        .replace(/\u00c5/g, 'a') //Å
                        .replace(/\u00e5/g, 'a') //å
                        .replace(/\u00c8/g, 'e') //È
                        .replace(/\u00e8/g, 'e') //è
                        .replace(/\u00c9/g, 'e') //É
                        .replace(/\u00e9/g, 'e') //é
                        .replace(/\u00ca/g, 'e') //Ê
                        .replace(/\u00ea/g, 'e') //ê
                        .replace(/\u00cb/g, 'e') //Ë
                        .replace(/\u00eb/g, 'e') //ë
                        .replace(/\u00cc/g, 'i') //Ì
                        .replace(/\u00ec/g, 'i') //ì
                        .replace(/\u00cd/g, 'i') //Í
                        .replace(/\u00ed/g, 'i') //í
                        .replace(/\u00ce/g, 'i') //Î
                        .replace(/\u00ee/g, 'i') //î
                        .replace(/\u00cf/g, 'i') //Ï
                        .replace(/\u00ef/g, 'i') //ï
                        .replace(/\u00d1/g, 'n') //Ñ
                        .replace(/\u00f1/g, 'n') //ñ
                        .replace(/\u00d2/g, 'o') //Ò
                        .replace(/\u00f2/g, 'o') //ò
                        .replace(/\u00d3/g, 'o') //Ó
                        .replace(/\u00f3/g, 'o') //ó
                        .replace(/\u00d4/g, 'o') //Ô
                        .replace(/\u00f4/g, 'o') //ô
                        .replace(/\u00d5/g, 'o') //Õ
                        .replace(/\u00f5/g, 'o') //õ
                        .replace(/\u00d6/g, 'o') //Ö
                        .replace(/\u00f6/g, 'o') //ö
                        .replace(/\u00f6/g, 'o') //ö
                        .replace(/\u00df/g, 'ss') //ß
                        .replace(/\u00d9/g, 'u') //Ù
                        .replace(/\u00f9/g, 'u') //ù
                        .replace(/\u00da/g, 'u') //Ú
                        .replace(/\u00fa/g, 'u') //ú
                        .replace(/\u00db/g, 'u') //Û
                        .replace(/\u00fb/g, 'u') //û
                        .replace(/\u00dc/g, 'u') //Ü
                        .replace(/\u00fc/g, 'u') //ü
                        .replace(/\u00dd/g, 'y') //Ý
                        .replace(/\u00fd/g, 'y') //ý
                        .replace(/\u0178/g, 'y') //Ÿ
                        .replace(/\u00ff/g, 'y'); //ÿ
                }
            });
        }, dispatcher);
    }
};

const buildNestedTree = (items, keepSpecLandingInGroup) => {
    let nestedTree = [];
    let options = [];
    if (items) {
        let [hasOptionsChecked, hasSpecLandingTermOptionsChecked] = [false, false];
        if (keepSpecLandingInGroup) {
            hasOptionsChecked = items.some(i => i.Checked);
            hasSpecLandingTermOptionsChecked = items.some(i => i.IsSpecLandingTerm && i.Checked);
        }
        items.forEach(option => {
            if (!option.ParentValue) {
                option.Visible = true;
                nestedTree.push(option);
            }
            if (keepSpecLandingInGroup && hasOptionsChecked) {
                if (hasSpecLandingTermOptionsChecked) {
                    option.Disabled = !option.IsSpecLandingTerm;
                }
                else {
                    option.Disabled = option.IsSpecLandingTerm;
                }
            }
        });
    }
    nestedTree.forEach(option => {
        options.push(option);
        let descendants = buildDescendants(items, option);
        option.Children = descendants.children;
        options = options.concat(descendants.options);
    });
    return {
        nestedTree: nestedTree,
        options: options
    };
};

const buildDescendants = (items, parent) => {
    let children = [];
    let options = [];
    // There could be overlap between the ParentValue and these Popular Items ID's
    if (!parent.IsPopularItem) {
        items.forEach(option => {
            if (option !== parent && parent.Value == option.ParentValue) {
                option.Visible = true;
                children.push(option);
            }
        });
        if (children.length > 0) {
            children.forEach(option => {
                options.push(option);
                if (option.IsGroup) {
                    let childObject = buildDescendants(items, option);
                    option.Children = childObject.children;
                    options = options.concat(childObject.options);
                }
            });
        }
    }
    return {
        children: children,
        options: options
    };
};

const applyFacet = (selectedOption, isChecked, options, nestedTree, parentNameForSearch, isSpecLandingTermFacet, keepSpecLandingInGroup) => {
    let newOptions = [];
    let newNestedTree = [];
    let checkedValues = [];
    let uncheckedValues = [];
    let excludedCheckedValues = [];
    let oneMustBeSelectedIndividually = nestedTree.some(option => option.MustBeSelectedIndividually);
    const getChildrenValues = (currentOption, optionIsChecked) => {
        let children = options.filter(option => option.ParentValue == currentOption.Value);
        if (children.some(c => c.Checked)) {
            children.forEach(option => {
                if (optionIsChecked) {
                    checkedValues.push(option);
                    excludedCheckedValues.push(option.ReactKey);
                } else {
                    uncheckedValues.push(option.ReactKey);
                }
            });
        } else {
            children.forEach(option => excludedCheckedValues.push(option.ReactKey));
        }
        if (children.some(c => c.IsGroup && c.Children && c.Children.length > 0)) {
            children.filter(c => c.IsGroup && c.Children && c.Children.length > 0).forEach(option => getChildrenValues(option, option.Checked));
        }
    };
    const getParentValues = (currentOption, optionIsChecked) => {
        let parent = options.filter(option => option.Value == currentOption.ParentValue)[0];
        if (parent) {
            let parentIsChecked = false;
            let childrendUnderParent = options.filter(option => option.ParentValue == parent.Value);
            // if any children are not checked, uncheck the parent:
            if (!optionIsChecked || childrendUnderParent.some(c => !c.Checked)) {
                uncheckedValues.push(parent.ReactKey);
            } else {
                // otherwise check the parent and uncheck all the children:
                parentIsChecked = true;
                checkedValues.push(parent);
                childrendUnderParent.forEach(c => excludedCheckedValues.push(c.ReactKey));
            }
            if (parent.ParentValue) {
                getParentValues(parent, parentIsChecked);
            }
        }
    };
    const checkOption = (option) => {
        let newOption = { ...option };
        if (newOption.ReactKey == selectedOption.ReactKey && ((newOption.IsGroup && selectedOption.IsGroup) || (!newOption.IsGroup && !selectedOption.IsGroup))) {
            newOption.Checked = isChecked;
        }
        if (isSpecLandingTermFacet && isChecked) {
            if (selectedOption.IsSpecLandingTerm) {
                //if spec landing term facet and last selection was spec landing term, uncheck any non-spec landing terms
                newOption.Checked = newOption.Checked && newOption.IsSpecLandingTerm;
            }
            else {
                //if spec landing term facet and last selection was non spec landing term, uncheck any spec landing terms
                newOption.Checked = newOption.Checked && !newOption.IsSpecLandingTerm;
            }
        }
        if (newOption.Checked && uncheckedValues.indexOf(newOption.ReactKey) < 0 && ((excludedCheckedValues.indexOf(newOption.ReactKey) < 0) || (parentNameForSearch && newOption.IsGroup))) {
            checkedValues.push(newOption);
        }
        if (uncheckedValues.length > 0) {
            let uncheckedIndex = uncheckedValues.indexOf(newOption.ReactKey);
            if (uncheckedIndex > -1) {
                uncheckedValues.splice(uncheckedIndex, 1);
                newOption.Checked = false;
            }
        }
        let checkedIndex = checkedValues.findIndex(facet => facet.ReactKey == newOption.ReactKey);
        if (checkedIndex > -1) {
            newOption.Checked = true;
        }

        if (keepSpecLandingInGroup) {
            let hasOptionsChecked = options.some(op => op.Checked && op.ReactKey != selectedOption.ReactKey);
            if (isChecked || hasOptionsChecked) {
                let hasSpecLandingTermOptionsChecked = options.some(op => op.IsSpecLandingTerm && op.Checked);
                if (selectedOption.IsSpecLandingTerm) {
                    newOption.Disabled = !newOption.IsSpecLandingTerm && (isChecked || hasSpecLandingTermOptionsChecked);
                }
                else {
                    newOption.Disabled = newOption.IsSpecLandingTerm && (isChecked || !hasSpecLandingTermOptionsChecked);
                }
            }
            else {
                newOption.Disabled = false;
            }
        }

        return newOption;
    };
    const rebuildChildren = (parent) => {
        let children = [];
        parent.Children.map(option => {
            let newOption = checkOption(option);
            newOptions.push(newOption);
            if (newOption.IsGroup) {
                newOption.Children = rebuildChildren(newOption);
            }
            children.push(newOption);
        });
        return children;
    };
    // checkbox click logic starts here:
    if (oneMustBeSelectedIndividually) {
        if (selectedOption.MustBeSelectedIndividually && isChecked) {
            // if selected option is MustBeSelectedIndividually and is checked then deselect other values:
            nestedTree.forEach(option => {
                if (option.Value != selectedOption.Value) {
                    uncheckedValues.push(option.ReactKey);
                }
            });
        } else if (isChecked && nestedTree.some(option => option.MustBeSelectedIndividually && option.Checked)) {
            // if selected option is not MustBeSelectedIndividually then deselect any MustBeSelectedIndividually options if there are any checked:
            nestedTree.forEach(option => {
                if (option.MustBeSelectedIndividually) {
                    uncheckedValues.push(option.ReactKey);
                }
            });
        }
    }
    // if selected option was just checked and has children, uncheck them all, otherwise ignore they would be unchecked anyways:
    if (selectedOption.IsGroup && selectedOption.Children && selectedOption.Children.length > 0) {
        getChildrenValues(selectedOption, isChecked);
    }
    // if selected option is a child itself, handle parent selections, 
    // either we checked the last child to complete a parent selection, we checked child and need to deselect all parents, or no parents are selected anyways so we do nothing:
    if (selectedOption.ParentValue) {
        getParentValues(selectedOption, isChecked);
    }

    // update all option checkboxes and sync up the family tree:
    newNestedTree = [...nestedTree].map(option => {
        let newOption = checkOption(option);
        newOptions.push(newOption);
        if (newOption.IsGroup) {
            newOption.Children = rebuildChildren(newOption);
        }
        return newOption;
    });
    return {
        options: newOptions,
        nestedTree: newNestedTree,
        currentFilter: checkedValues
    };
};

export default facetedSearchReducer;
export { buildNestedTree, applyFacet };